import React from 'react'
import makeSticky from '~/tools/sticky'
import resize from '~/tools/resize'
import enhanceWithClickOutside from 'react-click-outside'
import './styles.css'


class TeamMasthead extends React.Component {
	constructor(){
		super();
		this.state={
			teamNavOpen:false
		}
		this.mobileNavOpen = this.mobileNavOpen.bind(this)
		this.handleScroll = this.handleScroll.bind(this)
		this.handleResize = this.handleResize.bind(this)
	}

	componentDidMount(){
		window.addEventListener('scroll', this.handleScroll)
		window.addEventListener('resize',this.handleResize)
	}

	handleScroll(){
		makeSticky(this.teamMasthead)
	}

	handleResize(){
		resize(this.teamMasthead)
	}

	mobileNavOpen(){
		this.setState({
			teamNavOpen: !(this.state.teamNavOpen)
		})
	}

	handleClickOutside(e){
		this.setState({
			teamNavOpen:false
		})
	}

	render(){
		const {settings} = this.props.layout

		return(
			<div className="team-masthead" ref={div => this.teamMasthead = div}>
				<div className="team-masthead-container" style={{ backgroundColor: settings.backgroundColor}}>
					<div className="team-logo-container">
						<div className="team-logo"><img src={settings.image}/></div>
						<div className="team-name">{settings.title}</div>
					</div>
					<div className="team-nav">
						{
							settings.links && settings.links.map(link => {
								return <a href={link.displayedPath} key={link.id}> {link.title} </a>
							})
						}
						<div className="social-media">
							{
								settings.socialLinks &&	settings.socialLinks.map(link => {
									return <a href={link.displayedPath} target="_blank" key={link.id} className={`connect-circle ${link.title.toLowerCase()}`}><span className={`ion-social-${link.title.toLowerCase()}`}></span></a>
								})
							}
						</div>
					</div>
					<div className="mobile-team-nav" onClick={this.mobileNavOpen}>
						<div className="mobile-dots">
							<span className="small-rect"></span>
							<span className="small-rect"></span>
							<span className="small-rect"></span>
						</div>
						{this.state.teamNavOpen && 
							<div className="team-mobile-nav">
								{
								settings.links && settings.links.map(link => {
										return <a href={link.displayedPath} key={link.id}> {link.title} </a>
									})
								}

								{
								settings.socialLinks && settings.socialLinks.map(link => {
										return <a href={link.displayedPath} target="_blank" key={link.id} className={`connect-circle ${link.title.toLowerCase()}`}><span className={`ion-social-${link.title.toLowerCase()}`}></span>{link.title}</a>
									})
								}

							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

export default enhanceWithClickOutside(TeamMasthead)
